var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m27.915 12.087-5.557-.085 2.115 2.127-6.155 6.188 1.41 1.418 6.156-6.188L28 17.674zm-3.36 14.074v-6.413l1.83-1.84V27a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V14.54a1 1 0 0 1 1-1h8.822l-1.831 1.84h-6.16v10.78z",
  clipRule: "evenodd"
})));
export default SvgExit;